module.exports = __webpack_public_path__ + "img/extended.4888f624.png";